function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import Backbone from '@polleverywhere/backbone';
import Provider from './provider';
import google from './google';
import apple from './apple';
var PROVIDER_CONFIG = {
  google: google,
  apple: apple
};

function getLabel(provider, labelName) {
  return provider.labels[labelName];
}

var SSOProviders = /*#__PURE__*/function (_Backbone$View) {
  _inheritsLoose(SSOProviders, _Backbone$View);

  function SSOProviders() {
    return _Backbone$View.apply(this, arguments) || this;
  }

  var _proto = SSOProviders.prototype;
  /**
  * @param {Object} options Configuration options.
  * @param {String} options.labelName The name of the label to display on each
  *   provider button
  * @param {Object<string, Object>} options.providers Hash of sso providers
  * @param {Function} options.providers[].callbackFn Function is called with an
  *   Oauth2Redirect instance when the provider button is clicked. It is this
  *   function's responsibility to redirect the client to the oauth2 redirect
  *   url
  */

  _proto.initialize = function initialize(options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    this.options = _.defaults(options, {
      providers: {},
      labelName: 'signIn'
    });
    this.providers = Object.entries(this.options.providers).map(function (_ref) {
      var name = _ref[0],
          callbackFn = _ref[1].callbackFn;
      var providerConfig = PROVIDER_CONFIG[name];

      if (!providerConfig) {
        throw new Error("SSO provider '" + name + "' not supported");
      }

      var label = getLabel(providerConfig, _this.options.labelName);
      var provider = new Provider(Object.assign({
        label: label,
        callbackFn: callbackFn
      }, providerConfig));
      provider.on('all', _this.trigger.bind(_this));
      return provider;
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    this.providers.map(function (provider) {
      return _this2.$el.append(provider.render().$el);
    });
    return this;
  };

  _proto.remove = function remove() {
    this.providers.map(function (provider) {
      return provider.remove();
    });

    _Backbone$View.prototype.remove.call(this);
  };

  _createClass(SSOProviders, [{
    key: "className",
    get: function get() {
      return 'component-auth__sso-providers';
    }
  }]);

  return SSOProviders;
}(Backbone.View);

export { SSOProviders as default };